import { getUserInfo } from "../../Config/Auth";

export const hasPermission = (requiredPermission) => {
  const user = getUserInfo();
  if (!user) return false;

  if (user.role === 'HS-Admin') return true;

  if (!requiredPermission) return true;

  if (!user.permissions) return false;

  const { section, keys } = requiredPermission;
  if (!Array.isArray(keys) || keys.length === 0) return false;

  const normalizedSection = section?.toLowerCase();

  const sectionAliasMap = {
    site_users: 'siteusers',
  };

  const mappedSection = sectionAliasMap[normalizedSection] || normalizedSection;

  const userPermissions = Object.fromEntries(
    Object.entries(user.permissions).map(([key, value]) => [key.toLowerCase(), value])
  );

  const userSectionPermissions = userPermissions[mappedSection] || [];

  return keys.some((key) => userSectionPermissions.includes(key));
};